module.exports = __webpack_public_path__ + "img/modal-segment-destroy.c11a919b.svg";